// extracted by mini-css-extract-plugin
export var breadcrumb = "_1-0";
export var breadcrumbArrow = "_1-1";